import { Price } from '@util/Currency';
import { Alert } from 'antd';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { useAppStore } from '../../../store/Store';
import { PricingSelector } from '../../../store/pricing/PricingActions';

/** The applied coupon's discount, e.g. "25%" or "$10.00", or undefined when there is none. */
export function useCouponDiscount(): string | undefined {
  const { percentOff, amountOff, currency } = useAppStore((state) => ({
    percentOff: Math.floor(PricingSelector.percentRatioOff(state.pricing) * 100),
    amountOff: PricingSelector.amountOff(state.pricing),
    currency: state.pricing.currency,
  }));

  if (percentOff > 0) return `${percentOff}%`;
  if (amountOff > 0) return Price.formatWithCurrency(amountOff, currency);
  return undefined;
}

export const Coupon: FunctionComponent = () => {
  const discount = useCouponDiscount();
  return discount !== undefined ? <CouponAlert message={`${discount} discount applied!`} /> : null;
};

const CouponAlert = styled(Alert).attrs({
  'data-test': 'couponAlert',
  type: 'success',
  showIcon: true,
  closable: true,
})`
  position: sticky;
  top: 0;
  z-index: 1000;
  margin-bottom: 0px;
`;
